import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import type { FormEvent } from "react";
import { Callout } from "@/shared/ui/callout";
import type { LoadingState } from "@/features/auth/ui/login-form/use-login-flow";

interface EmailStepProps {
  email: string;
  error: string | null;
  loading: LoadingState;
  onEmailChange: (email: string) => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export function EmailStep({ email, error, loading, onEmailChange, onSubmit }: EmailStepProps) {
  return (
    <Stack component="form" onSubmit={onSubmit} spacing={2.5}>
      {error && <Callout severity="error">{error}</Callout>}
      <TextField
        id="email"
        label="Email"
        type="email"
        value={email}
        onChange={(event) => onEmailChange(event.target.value)}
        required
        disabled={loading !== null}
        autoComplete="email"
        autoFocus
        fullWidth
      />
      <Button type="submit" variant="contained" disabled={loading !== null} fullWidth>
        {loading === "tenant" ? "Checking..." : "Continue"}
      </Button>
    </Stack>
  );
}
